export default __webpack_public_path__ + "static/Ultrasound-mode-381614c41eedca2721486eb6455de95e.png";